export enum RockQuarter {
  Q1 = 'Q1',
  Q2 = 'Q2',
  Q3 = 'Q3',
  Q4 = 'Q4',
  none = 'None',
}

export interface CreateRockRequestModel {
  rock: {
    userId: string;
    title: string;
    description?: string;
    dueDate: Date;
    companyId: string;
    teamId: string;
    additionalTeamIds?: string[];
    originalDueDate: Date;
    createdBy: string;
    statusCode: string;
    levelCode: string;
    quarter?: RockQuarter;
    rockQuarterYearDueDate?: Date;
  };
  userIds: string[];
  addCreatorToFollowersList: boolean;
}
